// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CUSTOM OHIF SCROLLBAR */
.ohif-scrollbar {
  scrollbar-color: #173239 transparent;
  overflow-y: auto;
}
.ohif-scrollbar-stable-gutter {
  scrollbar-gutter: stable;
}
.study-min-height {
  min-height: 450px;
}
.ohif-scrollbar:hover {
  overflow-y: auto;
}
.ohif-scrollbar::-webkit-scrollbar {
  scrollbar-width: thin;
}
.ohif-scrollbar::-webkit-scrollbar-track {
  border-radius: 0.25rem;
}
.ohif-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(42 127 123 / var(--tw-bg-opacity));
  background-color: #041c4a;
}
.ohif-scrollbar::-webkit-scrollbar-thumb:window-inactive {
  --tw-bg-opacity: 1;
  background-color: rgb(42 127 123 / var(--tw-bg-opacity));
  background-color: #041c4a;
}
/* INVISIBLE SCROLLBAR */
.invisible-scrollbar {
  scrollbar-width: none;
}
.invisible-scrollbar::-webkit-scrollbar {
  display: none;
}
.invisible-scrollbar::-webkit-scrollbar-track {
  display: none;
}
.invisible-scrollbar::-webkit-scrollbar-thumb {
  display: none;
}
.invisible-scrollbar::-webkit-scrollbar-thumb:window-inactive {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/assets/styles.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,gBAAgB;AAClB;AAEA;EACE,wBAAwB;AAC1B;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,qBAAqB;AACvB;AAGE;EAAA;AAAc;AAId;EAAA,sBAAc;EACd,kBAAwB;EAAxB,wDAAwB;EACxB;AAFc;AAMd;EAAA,kBAAwB;EAAxB,wDAAwB;EACxB;AADwB;AAI1B,wBAAwB;AACxB;EACE,qBAAqB;AACvB;AAGE;EAAA;AAAa;AAIb;EAAA;AAAa;AAIb;EAAA;AAAa;AAIb;EAAA;AAAa","sourcesContent":["/* CUSTOM OHIF SCROLLBAR */\r\n.ohif-scrollbar {\r\n  scrollbar-color: #173239 transparent;\r\n  overflow-y: auto;\r\n}\r\n\r\n.ohif-scrollbar-stable-gutter {\r\n  scrollbar-gutter: stable;\r\n}\r\n\r\n.study-min-height {\r\n  min-height: 450px;\r\n}\r\n\r\n.ohif-scrollbar:hover {\r\n  overflow-y: auto;\r\n}\r\n\r\n.ohif-scrollbar::-webkit-scrollbar {\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.ohif-scrollbar::-webkit-scrollbar-track {\r\n  @apply rounded;\r\n}\r\n\r\n.ohif-scrollbar::-webkit-scrollbar-thumb {\r\n  @apply rounded;\r\n  @apply bg-secondary-dark;\r\n  background-color: #041c4a;\r\n}\r\n\r\n.ohif-scrollbar::-webkit-scrollbar-thumb:window-inactive {\r\n  @apply bg-secondary-dark;\r\n  background-color: #041c4a;\r\n}\r\n\r\n/* INVISIBLE SCROLLBAR */\r\n.invisible-scrollbar {\r\n  scrollbar-width: none;\r\n}\r\n\r\n.invisible-scrollbar::-webkit-scrollbar {\r\n  @apply hidden;\r\n}\r\n\r\n.invisible-scrollbar::-webkit-scrollbar-track {\r\n  @apply hidden;\r\n}\r\n\r\n.invisible-scrollbar::-webkit-scrollbar-thumb {\r\n  @apply hidden;\r\n}\r\n\r\n.invisible-scrollbar::-webkit-scrollbar-thumb:window-inactive {\r\n  @apply hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
